import { render, staticRenderFns } from "./DonutHubFailedProduct.vue?vue&type=template&id=cce8cd18&lang=pug&"
import script from "./DonutHubFailedProduct.vue?vue&type=script&lang=ts&"
export * from "./DonutHubFailedProduct.vue?vue&type=script&lang=ts&"
import style0 from "./DonutHubFailedProduct.vue?vue&type=style&index=0&id=cce8cd18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports